import React from 'react'
import '../../Assets/Css/OurFounder.css'
import FounderImage from '../../Assets/Images/Founder.png'
const OurFounder = () => {
    return (
        <div className="founder-container">
        <h1 className='our-founder'>Our Founder</h1>
        <div className="founder-content">
          <h3><span style={{ color: '#FDB813' }}>S. Lakshman Kumar</span>: The visionary behind Prince Pictures</h3>
          <p>
            S. Lakshman Kumar established the company with a strong commitment to bringing quality films to the industry. With a deep passion for storytelling and a knack for recognizing talent, he has steered the production house toward success with projects like Sardar and Lubber Pandhu.
          </p>
        </div>
        {/* Add the image below the content */}
        <div className="founder-image">
          <img src={FounderImage} alt="S. Lakshman Kumar" />
        </div>
      </div>
  )
}

export default OurFounder